export default "__VITE_ASSET__1HtMClS0__"